/** 接受一个异步函数，针对这个异步函数的相同参数，同时只会有一次执行 */
export const oneRequestForSameParam = <T extends (...args: any[]) => Promise<any>>(fn: T) => {
  const requestMap = new Map<string, ReturnType<T>>();

  return (...args: Parameters<T>): ReturnType<T> => {
    // 将参数序列化为字符串，用于在Map中作为键
    const key = JSON.stringify(args);

    if (requestMap.has(key)) {
      return requestMap.get(key) as ReturnType<T>;
    }
    const promise = fn(...args) as ReturnType<T>;
    requestMap.set(key, promise);

    promise.finally(() => {
      requestMap.delete(key);
    });
    return promise;
  };
};
